(function ($) {
	"use strict";

	$(window).on('load', function() {
		VegasListener.onLoad();
	});

	$(window).scroll(function () {
		VegasListener.onScroll($(this));
	});

	$(window).resize(function () {
		VegasListener.onResize($(this));
	});

	$(document).ready(function () {
		VegasListener.onReady();
		VegasListener.onClick();
	});

	// [vegas]
	Vegas.log();
})(jQuery);